import Vue from 'vue'
import VueRouter from 'vue-router'
import { Notify } from 'vant'

Vue.use(VueRouter)

let routes = [{
    path: '/',
    name: 'index',
    component: _ => import('@/views/index')
}, {
    path: '/login',
    name: 'login',
    component: _ => import('@/views/login'),
    // meta: {
    //     hideInHistory: true
    // }
}, {
    path: '/courseDetails',
    name: 'courseDetails',
    component: _ => import('@/views/courseDetails')
}, {
    path: '/exam',
    name: 'exam',
    component: _ => import('@/views/exam/index')
}, {
    path: '/exam/answer',
    name: 'answer',
    component: _ => import('@/views/exam/answer')
}, {
    path: '/trial',
    name: 'trial',
    component: _ => import('@/views/courseDetails/trial')
}]

let router = new VueRouter({
    routes
})

// 判断浏览器类型
let browserType = _ => {
    let { userAgent } = window.navigator
    const isOpera = userAgent.includes("Opera") || userAgent.includes("OPR")
    const isQQ = userAgent.includes("QQBrowser")
    const isUC = userAgent.includes("UBrowser")
    const isIE = userAgent.includes("compatible") && userAgent.includes("MSIE")
    const isIE11 = userAgent.includes("Trident") && !userAgent.includes("compatible")
    const isEdge = userAgent.includes("Edge") || userAgent.includes("Edg")
    const isFF = userAgent.includes("Firefox")
    const isSafari = userAgent.includes("Safari") && !userAgent.includes("Chrome")
    const isChrome = userAgent.includes("Chrome") && userAgent.includes("Safari")
    const is360 = isChrome && (userAgent.includes("WOW") || userAgent.includes("360SE"))
    if (isIE) return "IE"
    if (isIE11) return "IE11"
    if (isEdge) return "Edge"
    if (isOpera) return "Opera"
    if (isQQ) return "QQBrowser"
    if (isUC) return "UC"
    if (isFF) return "Firefox"
    if (isSafari) return "Safari"
    if (is360) return "360"
    if (isChrome) return "Chrome"
    return "Unknown"
}

router.beforeEach((to, from, next) => {
    let browser = browserType()
    if(browser != 'Chrome' && window.location.hostname != 'localhost'){
        return Notify({ type: 'warning', message: '当前浏览器为' + browser + '请换用最新版Chrome浏览器' })
    }
    // 当前往登录页面时，清除登录状态
    if (to.path === '/login') {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
    }
        next()

})

export default router
